module.exports = __webpack_public_path__ + "static/media/fm_circle.070544b2.svg";